import {
  addDatasetFromForm,
  applyRecipe,
  getAllReusableTransforms,
  loadRecipeBuilderResources,
  markFormCompleted,
  setFormAwaitingValidation,
  setFormError,
  splitDataSet,
  updateDataSetRecipe,
  updateFormData,
} from 'js/actions';
import {
  GET_CODE_CONTAINERS_REQUEST,
  GET_PUBLIC_CODE_CONTAINERS_REQUEST,
} from 'js/constants/actionTypes';
import { FORM_TYPE_CREATE_DATASET } from 'js/constants/formTypes';
import * as OLD_PATHS from 'js/constants/pathnames';
import { ROUTE_REDESIGN } from 'js/constants/pathnames';
import UIUtils from 'js/lib/UIUtils';
import { has, isEmpty } from 'lodash';
import { ROUTE_CONNECT } from 'new/constants/pathnames';
import { connect } from 'react-redux';
import SendDataForm from './SendDataForm';

const mapStateToProps = (state, ownProps) => {
  const {
    entities: { dataSets, flowNodes, transforms },
    forms,
    dataSetSchemas,
    paging,
    schemaEditor: {
      fromSamples: { fromNested: inputSamples },
      toSamples: { toRaw: rawOutputSamples, toUpdatedAt: outputSamplesUpdatedAt },
      toSchema,
      lastInitialized: schemaEditorInitialized,
    },
    recipeBuilder: { recipeGroups, isRecipeUnapplied, isLegacyMode },
    splitter,
    transforms: { reusableRecordTransforms },
    vendors: vendorsState,
    routes: { currentPath, previousPath },
    request,
    recipeBuilder,
  } = state;

  const currentDataSetId = ownProps.id || UIUtils.extractParamFromURL(ownProps.match);

  let form = forms[FORM_TYPE_CREATE_DATASET];
  let currentStage = form ? form.currentStage : 0;
  let formData = form ? form.data : null;

  //data model 2.0
  let addedDatasetId = has(formData, 'addedDatasetId') ? formData.addedDatasetId : null;
  let addedDataset = addedDatasetId ? dataSets[addedDatasetId] : null;

  const isEditMode =
    ownProps.isEditMode ||
    ownProps.location?.pathname?.endsWith?.('/edit') ||
    (ownProps.isModal && addedDatasetId);

  let fromDataSetId = null;
  let toDataSetId = null;

  if (isEditMode) {
    toDataSetId = addedDatasetId || currentDataSetId;
  } else {
    fromDataSetId = currentDataSetId;
  }

  let toDataSet = dataSets[toDataSetId];
  let toDataSetSchema = dataSetSchemas[toDataSetId];

  const dataSet = dataSets[currentDataSetId];
  const isSplitMode =
    ownProps.location?.pathname?.endsWith?.('/split') ||
    (isEditMode && toDataSet?.node_type === 'splitter');
  const flow = flowNodes[dataSet?.origin_node_id];

  if (!fromDataSetId && !isEmpty(toDataSet?.parent_data_sets)) {
    fromDataSetId = toDataSet.parent_data_sets[0].id;
  }

  let fromDataSet = dataSets[fromDataSetId];
  let fromDataSetSchema = dataSetSchemas[fromDataSetId]?.out;

  let outputSchema = toSchema?.flat || [];
  let rawOutputSchema = toSchema?.raw || {};

  let isLoadingReusableTransforms = !!(
    request[GET_CODE_CONTAINERS_REQUEST] || request[GET_PUBLIC_CODE_CONTAINERS_REQUEST]
  );
  let vendorsLoaded = vendorsState.vendors.lastUpdated;
  let transformsLoaded =
    reusableRecordTransforms.lastUpdated && reusableRecordTransforms.lastUpdatedPublic;

  const destinationDraft = recipeBuilder?.destinationDraft;

  return {
    paging,
    transforms,
    fromDataSetId,
    fromDataSet,
    fromDataSetSchema,
    toDataSetId,
    toDataSet,
    flowType: dataSet?.flow_type || flow?.flow_type,
    toDataSetSchema: isEmpty(outputSchema) ? toDataSetSchema?.out : outputSchema,
    isEditMode,
    isSplitMode,
    currentStage,
    formData,
    addedDataset,
    recipeGroups,
    splitter,
    isRecipeUnapplied,
    isLegacyMode,
    outputSchema,
    inputSamples,
    rawOutputSchema,
    rawOutputSamples,
    outputSamplesUpdatedAt,
    isLoadingReusableTransforms,
    vendorsLoaded,
    transformsLoaded,
    schemaEditorInitialized,
    currentPath,
    previousPath,
    destinationDraft,
  };
};

const SendDataFormContainer = connect(mapStateToProps, {
  loadRecipeBuilderResources,
  getAllReusableTransforms,
  updateFormData,
  setFormError,
  setFormAwaitingValidation,
  markFormCompleted,
  applyRecipe,
  addDatasetFromForm,
  updateDataSetRecipe,
  splitDataSet,
})(SendDataForm);

SendDataFormContainer.screenConfig = {
  screenName: 'SendDataForm',
  domain: 'integrate',
  hideSideBar: true,
  pageTitle: 'Send Data',
  path: [
    `${ROUTE_REDESIGN}${ROUTE_CONNECT}${OLD_PATHS.ROUTE_MY_DATA_SETS}/:id/new`,
    `${ROUTE_REDESIGN}${ROUTE_CONNECT}${OLD_PATHS.ROUTE_MY_DATA_SETS}/:id/edit`,
    `${ROUTE_REDESIGN}${ROUTE_CONNECT}${OLD_PATHS.ROUTE_MY_DATA_SETS}/:id/split`,
    `${ROUTE_REDESIGN}${ROUTE_CONNECT}${OLD_PATHS.ROUTE_DATA_SETS_SHARED_WITH_ME}/:id/new`,
  ],
};

export default SendDataFormContainer;
